/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Tab_ProfileInputs */

const en_us2_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const pt_br2_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const es_419_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const pt_pt2_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const fr_fr2_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const de_de2_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_it2_shell_tab_profile = /** @type {(inputs: Shell_Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Shell_Tab_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_tab_profile = /** @type {((inputs?: Shell_Tab_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Tab_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_tab_profile(inputs)
	if (locale === "es-419") return es_419_shell_tab_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_tab_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_tab_profile(inputs)
	if (locale === "de-DE") return de_de2_shell_tab_profile(inputs)
	if (locale === "it-IT") return it_it2_shell_tab_profile(inputs)
	return en_us2_shell_tab_profile(inputs)
});
export { shell_tab_profile as "shell.tab_profile" }